import { all, fork } from 'redux-saga/effects'

import adminWelcomeEmailGetSaga from './adminWelcomeEmailGetSaga'
import adminWelcomeEmailPostSaga from './adminWelcomeEmailPostSaga'
import adminWelcomeEmailPutSaga from './adminWelcomeEmailPutSaga'

export default function* adminOrganizationWelcomeEmailSaga() {
  yield all([fork(adminWelcomeEmailGetSaga), fork(adminWelcomeEmailPostSaga), fork(adminWelcomeEmailPutSaga)])
}
